import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../index';

interface PlayerState {
  progress: number;
  volume: number;
  isMuted: boolean;
  playbackSpeed: number;
  quality: string;
}

const initialState: PlayerState = {
  progress: 0,
  volume: 1,
  isMuted: false,
  playbackSpeed: 1,
  quality: 'auto',
};

const playerSlice = createSlice({
  name: 'player',
  initialState,
  reducers: {
    setVideoProgress: (state, action: PayloadAction<number>) => {
      state.progress = action.payload;
    },
    setVolume: (state, action: PayloadAction<number>) => {
      state.volume = action.payload;
    },
    setMuted: (state, action: PayloadAction<boolean>) => {
      state.isMuted = action.payload;
    },
    setPlaybackSpeed: (state, action: PayloadAction<number>) => {
      state.playbackSpeed = action.payload;
    },
    setVideoQuality: (state, action: PayloadAction<string>) => {
      state.quality = action.payload;
    },
  },
});

export const {
  setVideoProgress,
  setVolume,
  setMuted,
  setPlaybackSpeed,
  setVideoQuality,
} = playerSlice.actions;

// Selectors
export const selectVideoProgress = (state: RootState) => state.player.progress;
export const selectVolume = (state: RootState) => state.player.volume;
export const selectIsMuted = (state: RootState) => state.player.isMuted;
export const selectPlaybackSpeed = (state: RootState) => state.player.playbackSpeed;
export const selectVideoQuality = (state: RootState) => state.player.quality;

export default playerSlice.reducer; 